import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0cab146c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "info-warp"
};
const _hoisted_2 = {
  class: "tree-warp"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "tree-info"
};
const _hoisted_5 = {
  class: "select-warp"
};
const _hoisted_6 = {
  class: "header"
};
const _hoisted_7 = {
  class: "title-name"
};
const _hoisted_8 = {
  class: "select-list"
};
const _hoisted_9 = {
  class: "select-item"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1,
  class: "empty"
};
import SearchInput from '@/components/SearchInput/index.vue';
import { getCurrentInstance, nextTick, reactive, inject, onMounted } from 'vue';
import { useCommon } from '@/store/useCommon';
import { getAgentCategoryApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    programType: {
      type: String,
      default: 'movie'
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      proxy
    } = getCurrentInstance();
    const defaultProps = {
      children: 'children',
      label: 'name',
      disabled: 'disabled'
    };
    const finishData = inject('finishData');
    onMounted(() => {
      let videoCodeArr = []; // TODO：接口返回videoCode再处理一下，这里有bug
      // try {
      //     if(finishData.value.programType=='movie' && finishData.value.mediaList) {
      //     // 电影
      //         finishData.value.mediaList.mediaList.forEach(item=> {
      //             item.mediaContentList.forEach(media => {
      //                     videoCodeArr.push(media.videoCode)
      //                 })
      //         })
      //     } else {
      //         // 电视剧
      //         finishData.value.tvSeasonMediaList.forEach(tvs => {
      //             tvs.tvEpisodesList.forEach(item => {
      //                 item.mediaContentList.forEach(item => {
      //                     videoCodeArr.push(item.videoCode)
      //                 })
      //             })
      //         })
      //     }
      // } catch (error) {
      //     console.log('93-error', error)
      // }
      // 判断编码协议数组中是否包含h265协议，什么都没有就默认请求h264
      // h264显示所有的品牌，传''， h265只显示h265的品牌

      let videoCode = videoCodeArr.includes('H265') ? 'H265' : videoCodeArr.includes('H264') ? '' : '';
      console.log('videoCode', videoCode);
      getCategoryList(videoCode);
    });
    const mediaParams = inject('mediaParams');
    const dataInfo = reactive({
      list: [],
      selectList: [],
      showLoading: false
    });
    expose({
      dataInfo
    }); // 搜索框配置

    const searchConfig = reactive({
      formData: {
        keyword: ''
      },
      formList: [{
        label: '关键字',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        style: "width: 260px"
      }]
    });

    const filterNode = (value, data) => {
      if (!value) return true;
      return data.name.includes(value);
    }; // 递归设置父节点全部选中


    const setParentNode = node => {
      if (node.parent) {
        for (const key in node) {
          if (key === 'parent') {
            node[key].checked = true;
            setParentNode(node[key]);
          }
        }
      }
    }; // 递归设置子节点全部取消选中


    const setChildNode = node => {
      if (node.childNodes && node.childNodes.length) {
        if (!node.checked) {
          node.childNodes.forEach(item => {
            item.checked = false;
            setChildNode(item);
          });
        } else {
          node.childNodes.forEach(item => {
            item.checked = true;
            setChildNode(item);
          });
        }
      }
    };

    const treeRef = ref();

    const handleSearch = data => {
      treeRef.value.filter(data.keyword);
    };

    const handleReset = () => {
      treeRef.value.filter();
    }; // 复选框点击事件


    const handleCheck = (data, change) => {
      const treeRef = proxy.$refs.treeRef;
      let nodes = treeRef.getCheckedNodes().concat(treeRef.getHalfCheckedNodes()); // 过滤出子节点，也就是不含childred字段的节点数据

      let filterNodes = nodes.filter(node => {
        return node.children === null;
      });
      dataInfo.selectList = filterNodes; // 赋值给表格数据
    }; // 删除按钮


    const deleteRow = (index, id) => {
      const treeRef = proxy.$refs.treeRef;
      treeRef.setChecked(id, false); // 取消左侧复选框的选中状态

      dataInfo.selectList.splice(index, 1); // 从tableData中删除数据
    }; // 回显选中状态


    const selection = arrDa => {
      nextTick(() => {
        const treeRef = proxy.$refs.treeRef;
        arrDa && arrDa.length && treeRef.setCheckedKeys(arrDa, true);
      });
    };

    const getCategoryList = async (videoCode = 'H264') => {
      dataInfo.showLoading = true;
      dataInfo.selectList = [];
      const cid = mediaParams.value ? useCommon().userData.cid[0] || 0 : sessionStorage.getItem('currentCid');
      let videoType = []; // const movieOrTvData = props.programType === 'movie' ? finishData.value.mediaList.mediaList : finishData.value.tvSeasonMediaList;
      // if (props.programType === 'movie') {
      //     movieOrTvData.forEach(item => {
      //         item.mediaContentList.forEach(listItem => {
      //             videoType.push(listItem.videoCode);
      //         })
      //     })
      //     videoType = [...new Set(videoType)];
      // } else {
      //     movieOrTvData.forEach(item => {
      //         item.tvEpisodesList.forEach(listItem => {
      //             listItem.mediaContentList.forEach(videoItem => {
      //                 videoType.push(videoItem.videoCode);
      //             })
      //         })
      //     })
      //     videoType = [...new Set(videoType)];
      // }

      let params = {
        cid,
        type: 2,
        isFilterRelationAgent: true,
        videoCode
      };

      try {
        const res = await getAgentCategoryApi(params);
        let tempList = [];

        if (res.code == '0') {
          res.data.forEach(item => {
            if (!item.children || !item.children.length) {
              item.disabled = true;
            } else {
              setParentName(item.name, item, tempList);
            }
          });
          dataInfo.list = res.data;
          finishData.value.categoryIdList && finishData.value.categoryIdList.forEach(item => {
            let selectItem = tempList.find(tempItem => tempItem.id === item);

            if (selectItem) {
              dataInfo.selectList.push(selectItem);
            }
          });
        }
      } catch (error) {}

      selection(finishData.value.categoryIdList);
      dataInfo.showLoading = false;
    }; // 设置右侧选择列表回显数据


    const setParentName = (masterName, obj, arr) => {
      obj.children.forEach(child => {
        child.subBrandName = obj.name;
        child.masterBrandName = masterName;
        arr.push(child);

        if (child.children) {
          setParentName(masterName, child, arr);
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(SearchInput, {
        class: "search-input",
        labelWidth: "120px",
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset,
        size: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 12,
          xl: 12
        }
      }, null, 8, ["form-list", "form-data"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('分类列表')), 1), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_tree, {
        ref_key: "treeRef",
        ref: treeRef,
        "node-key": "id",
        "default-checked-keys": dataInfo.list,
        "default-expand-all": "",
        data: dataInfo.list,
        props: defaultProps,
        "filter-node-method": filterNode,
        "show-checkbox": "",
        onCheck: handleCheck
      }, null, 8, ["default-checked-keys", "data"])])), [[_directive_loading, dataInfo.showLoading]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('已选分类列表')), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('主品牌名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('子品牌名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('分类名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('操作')), 1)]), _createElementVNode("div", _hoisted_8, [dataInfo.selectList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataInfo.selectList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(item.masterBrandName), 1), _createElementVNode("span", null, _toDisplayString(item.subBrandName), 1), _createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", null, [_createElementVNode("span", {
          class: "delete",
          onClick: $event => deleteRow(index, item.id)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_10)])])]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('暂无数据')), 1))])])])]);
    };
  }

});